const binding = { modules: {}, dataActions: {} };

    (binding.modules['delivery-page'] = {
        c: () => require('partner/modules/delivery-page/delivery-page.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'delivery-page',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/delivery-page'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|delivery-page|delivery-page'] = {
                c: () => require('partner/modules/delivery-page/delivery-page.view.tsx'),
                cn: '__local__-__local__-delivery-page'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };